import {
  AbsoluteCenter,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  useToast,
  Stack,
  Tooltip,
  Box,
} from '@chakra-ui/react';
import { Spinner } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { EditIcon, AddIcon } from '@chakra-ui/icons';
import AddModal from './addModal';
import EditModal from './editModal';
import { usePermissions } from 'contexts/PermissionContext';
// Custom components
import Card from 'components/card/Card';
import VariantChargesApi from 'api/variantcharges';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import SavingPlanVariantApi from 'api/savingplanvariant';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import { Modules } from 'config/constant';
import { isValidUUID } from 'utils/fetchUtils';
import PageError from 'components/nopermission/PageError';

export default function TableData(props) {
  const id = IdFromUrl(window.location.href);
  function IdFromUrl(url) {
    const parts = url.split('/');
    const id = parts[parts.length - 1];
    return id;
  }
  const withId = props;
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const [isError, setIsError] = useState('');
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [listTotal, setListTotal] = useState(2);
  // const [totalPages, setTotalPages] = useState(0);
  const [error, setError] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [booleanFilter, setBooleanFilter] = useState('');
  const [isactive, setisactive] = useState();
  const [variantList, setvariantList] = useState([]);
  const [variantPermissions, setvariantPermissions] = useState(null);
  const { getPermissionsForModule } = usePermissions();
  const { permissions } = usePermissions();
  const [fetchListError, setFetchListError] = useState(false);

  const fetchVariantList = async () => {
    if (withId && !isValidUUID(id)) {
      return;
    }
    try {
      setLoading(true);
      let response = await SavingPlanVariantApi.List({
        currentPage,
        itemsPerPage,
        sort: 'name:asc',
        searchTerm,
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200 && response?.data?.list?.length > 0) {
        setvariantList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setvariantList(null);
        setListTotal(0);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const fetchList = async () => {
    if (withId && !isValidUUID(id)) {
      setFetchListError(true);
      return;
    }
    try {
      setLoading(true);
      let response = await VariantChargesApi.List({
        currentPage,
        itemsPerPage,
        sort: 'name:asc',
        searchTerm,
        booleanFilter,
        id,
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200) {
        setFetchListError(false);
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setFetchListError(true);
        setList(null);
        setListTotal(0);
      }
    } catch (err) {
      setFetchListError(true);
      console.log(err);
    }
  };
  useEffect(() => {
    const variantPermissions = getPermissionsForModule([
      Modules.SavingPlanVariant,
    ]);
    setvariantPermissions(variantPermissions);
    fetchList();
    fetchVariantList();
  }, [currentPage, searchTerm, id]);

  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  function getPropertyFromId(inputId, objects, property) {
    console.log('Params', inputId, objects, property);
    if (objects) {
      for (const obj of objects) {
        if (obj.id === inputId) {
          return obj[property];
        }
      }
    }
    return null; // Return null if ID not found
  }

  let totalPages = Math.ceil(listTotal / itemsPerPage);
  const pageItems = [];
  for (let i = 1; i <= totalPages; i++) {
    pageItems.push(
      <Button
        key={i}
        size='sm'
        variant='ghost'
        colorScheme={i === currentPage ? 'blue' : undefined}
        onClick={() => onPageChange(i)}>
        {i}
      </Button>
    );
  }
  const handleSearch = async (search) => {
    setSearchTerm(search);
    setCurrentPage(1); // Reset currentPage to 1 on each search
  };
  console.log('permissions', variantPermissions);

  if (!variantPermissions?.read) {
    return <NoPermissionsMessage module={Modules.SavingPlanVariant} />;
  }
  return fetchListError ? (
    <PageError />
  ) : (
    <Flex
      height='100%'
      direction='column'>
      <Flex></Flex>

      <Card
        direction='column'
        w='100%'
        px='0px'
        // mt={{ base: '180px', md: '120px' }}
        overflowX='hidden'>
        <Flex
          px='25px'
          justify='space-between'
          mb='20px'
          align='center'>
          <Text
            color={textColor}
            fontSize='22px'
            fontWeight='700'
            lineHeight='100%'></Text>
          <Flex gap={4}>
            <Tooltip
              label={
                !variantPermissions.create
                  ? 'You do not have permission to add'
                  : undefined
              }
              placement='top'
              shouldWrapChildren>
              <AddModal
                Icon={<AddIcon />}
                head={'Add New Charges for Variant'}
                func={fetchList}
                variantList={variantList}
                variantId={id}
                disabled={!variantPermissions.create}
              />
            </Tooltip>
          </Flex>
        </Flex>

        <Flex overflow='auto'>
          <Table
            variant='simple'
            color='gray.500'
            mb='24px'>
            <Thead>
              <Tr>
                {/* <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'>
                    Sr.no
                  </Flex>
                </Th> */}
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'>
                    Name
                  </Flex>
                </Th>
                <Th borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'>
                    Saving Plan
                  </Flex>
                </Th>
                <Th borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'>
                    Saving Plan Variant
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'>
                    Base Amount
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'>
                    GST (in %)
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'>
                    Total Amount
                  </Flex>
                </Th>
                <Th borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'>
                    Type
                  </Flex>
                </Th>
                <Th borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'>
                    Status
                  </Flex>
                </Th>
                <Th borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'>
                    Actions
                  </Flex>
                </Th>
              </Tr>
            </Thead>

            <Tbody>
              {loading ? (
                <Box height='300px'>
                  <AbsoluteCenter
                  // bgColor='red'
                  >
                    <Spinner size='xl' />
                  </AbsoluteCenter>
                </Box>
              ) : (
                list?.map((obj, index) => {
                  return (
                    <Tr key={obj.id}>
                      {/* <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'>
                            {(currentPage - 1) * 10 + (index + 1)}
                          </Text>
                        </Flex>
                      </Td> */}
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'>
                            {obj.name}
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'>
                            {getPropertyFromId(
                              obj.saving_plan_variant_id,
                              variantList,
                              'category'
                            )}
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'>
                            {getPropertyFromId(
                              obj.saving_plan_variant_id,
                              variantList,
                              'period'
                            )}
                            {" Months"}
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'>
                            {obj.base_amount}
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'>
                            {obj.gst}
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'>
                            {obj.total_amount}
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'>
                            {obj.type}
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        <Text
                          size='sm'
                          fontWeight='700'
                          color={
                            obj.is_active === true ? 'green' : { textColor }
                          }>
                          {obj.is_active === true ? 'ACTIVE' : 'INACTIVE'}
                        </Text>
                      </Td>
                      <Td>
                        <Flex align='center'>
                          <Tooltip
                            label={
                              !variantPermissions.update
                                ? 'You do not have permission to add'
                                : undefined
                            }
                            placement='top'
                            shouldWrapChildren>
                            <EditModal
                              Icon={<EditIcon />}
                              head={'Edit Charges for Variant'}
                              variantList={variantList}
                              initialData={obj}
                              id={obj.id}
                              error={error}
                              func={fetchList}
                              variantId={id}
                              disabled={!variantPermissions.update}
                            />
                          </Tooltip>
                        </Flex>
                      </Td>
                    </Tr>
                  );
                })
              )}
            </Tbody>
          </Table>
        </Flex>

        {/* display the pagination */}
        <Stack
          direction='row'
          spacing={2}
          mt={4}
          justifyContent='center'>
          <Box>
            <Button
              size='sm'
              isDisabled={currentPage === 1}
              onClick={() => onPageChange(currentPage - 1)}>
              Previous
            </Button>
          </Box>

          {pageItems}

          <Box>
            <Button
              size='sm'
              isDisabled={currentPage === totalPages}
              onClick={() => onPageChange(currentPage + 1)}>
              Next
            </Button>
          </Box>
        </Stack>
        {isError !== '' && <h2>{isError}</h2>}
      </Card>
    </Flex>
  );
}
